import './table.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Table = forwardRef((props, ref) => {
  const className = classNames({
    table: true,
    [`table-${props.type}`]: props.type,
    'table-bordered': props.bordered,
    [`table-${props.size}`]: props.size,
    [props.className]: props.className,
  });

  const table = (
    <table ref={ref} className={className}>
      {props.children}
    </table>
  );

  if (props.responsive) {
    return <div className="table-responsive">{table}</div>;
  }

  return table;
});

Table.propTypes = {
  type: PropTypes.oneOf(['default']),
  bordered: PropTypes.bool,
  responsive: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string,
  children: PropTypes.node,
};

Table.defaultProps = {
  type: 'default',
  bordered: false,
  responsive: false,
};

export default Table;
